import React from 'react';
import { Reveal } from './Reveal';
type Bonus = {
  number: string;
  title: string;
  description: string;
  featured?: boolean;
};
const bonuses: Bonus[] = [{
  number: 'BONUS 01',
  title: 'The Step Class Planner Printables',
  description: 'Weekly, monthly, and quarterly class planning templates with illustrated step pattern icons, BPM reference bars, and 32-count grids. Plan your entire year in minutes.'
}, {
  number: 'BONUS 02',
  title: 'Step Safety & Liability Checklist',
  description: 'Complete illustrated safety protocol system covering platform setup, contraindicated movements, at-risk client protocols, and print-ready incident report forms. Protect your clients and your career.'
}, {
  number: 'BONUS 03',
  title: 'Step Instructor Power Cues Glossary',
  description: 'Professional verbal cue scripts for every pattern organized by class phase with 32-count delivery timing. Say exactly the right thing at exactly the right moment.'
}, {
  number: 'BONUS 04',
  title: 'The 45° Step Alignment Poster',
  description: 'Large-format print-ready studio poster showing the complete biomechanical alignment guide for step training. Hang it in your studio and let it teach for you before class starts.'
}, {
  number: 'BONUS 05 — Most Requested',
  title: 'Step Class Social Media Hero Kit',
  description: '10 professionally designed Canva templates built exclusively for step instructors. Instagram posts, Facebook promotions, WhatsApp class announcements — fully branded and ready to post. Start filling your step classes every single week.',
  featured: true
}];
export function Bonuses() {
  return <section className="w-full bg-sky px-4 py-20 sm:py-24" data-id="element-19" data-mp="33gw6g80ugvzy">
      <div className="mx-auto max-w-6xl" data-id="element-20" data-mp="33jie07nqjbi6">
        <Reveal className="text-center" data-id="element-21" data-mp="nozyyrd6ka94">
          <h2 className="font-display text-3xl font-extrabold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-22" data-mp="ns49s7l5i48r">
            🎁 5 Exclusive <span className="text-green-dark" data-id="element-23" data-mp="3cj6h6da27qou">Bonus Resource Kits</span>
          </h2>
          <p className="mt-2 text-sm text-slate" data-id="element-24" data-mp="3hhzmhif70bdx">Included FREE with your purchase</p>
        </Reveal>
        <div className="mt-8 grid gap-5 md:grid-cols-2" data-id="element-25" data-mp="3ljl4tjahxhvi">
          {bonuses.map((bonus, index) => <Reveal key={bonus.number} delay={index % 2 * 0.06} className={index === 4 ? 'md:col-span-2 md:mx-auto md:w-[calc(50%-0.625rem)]' : ''} data-id="element-26" data-mp="3qiphijwmpxql" data-mpi={index}>
              <article className={`flex h-full flex-col rounded-2xl border bg-surface p-7 shadow-premium ${bonus.featured ? 'border-green' : 'border-sky-line'}`} data-id="element-27" data-mp="2xtqsd2u39vbs">
                <p className="text-xs font-bold uppercase tracking-[0.15em] text-green-dark" data-id="element-28" data-mp="37jju7c4fiw2u">{bonus.number}</p>
                <h3 className="mt-3 font-display text-xl font-bold leading-tight text-ink" data-id="element-29" data-mp="2a4zab4a7qtcq">{bonus.title}</h3>
                <p className="mt-3 text-sm leading-7 text-slate" data-id="element-30" data-mp="2f2qxxm3trtb4">{bonus.description}</p>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}